import { jwtToken } from "@webmotors/consumer-shared-auth";

import { useDeviceSize } from "@hooks/device-size";
import { useChatStore } from "@stores/chat.store";
import { useAdvertiserInit } from "@hooks/api/advertiser";

export function useApp() {
  useAdvertiserInit();
  const { isMobile } = useDeviceSize();
  const hasActiveConversation = !!useChatStore((s) => s.conversation.active);

  const showHeader = !isMobile || !hasActiveConversation;
  const showFooter = !isMobile || !hasActiveConversation;
  const authToken = jwtToken() ?? undefined;
  const portalBaseUrl =
    import.meta.env.VITE_URL_PORTAL ?? "https://hportal.webmotors.com.br";

  return {
    showHeader,
    showFooter,
    authToken,
    portalBaseUrl,
    footerConfig: {
      baseUrl: portalBaseUrl,
      enableCopiHelp: true,
      enableCookieManagement: true,
      copiAuthToken: authToken,
    },
  };
}
